import { Component, Inject, OnInit } from '@angular/core'
import {DOCUMENT} from "@angular/common";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styles: [],
})
export class AppComponent implements OnInit{
  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {
  //      let bases = this.document.getElementsByTagName('base');
  //    if (bases.length > 0) {
  //      bases[0].setAttribute('href', environment.BASE_HREF);
  // } 
  }

  ngOnInit(): void {
    this.loadScript()
    throw new Error('Method not implemented.');
  }

  loadScript() {
    /* Create your script */
    const body = <HTMLDivElement>document.body
    const script = document.createElement('script')
    script.async = true
    script.src = environment.ADOBE_ANALYTICS_URL
    /* add your script to DOM */
    body.appendChild(script)
  }
  public title = 'exemplar'
 
}

